import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
const supportsHistory = 'pushState' in window.history

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter forceRefresh={!supportsHistory}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)
serviceWorkerRegistration.register()
